import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../productPageStyle.js";

const useStyles = makeStyles(styles);

/**
 * B-01 §28.3 item 6.
 *
 * It sits immediately after the seven limits, not up in the certification
 * block: the limits are where a reader's doubt is created, so that is where
 * the way out belongs. The email address is always visible next to the button
 * — a reporter who distrusts the certifier's own form still has a route.
 */
export default function ReportBand({ t, onReportClick }) {
  const classes = useStyles();

  return (
    <div className={classes.reportBand}>
      <div className={classes.reportText}>
        <h2 className={classes.reportHeading}>{t.reportHeading}</h2>
        <p className={classes.reportBody}>{t.dialogIntro}</p>
        <div className={classes.reportEmailRow}>
          <span className={classes.reportEmailLabel}>{t.reportOrEmail}</span>
          <a
            className={classes.reportEmailLink}
            href={"mailto:" + t.contactEmail}
          >
            {t.contactEmail}
          </a>
        </div>
      </div>
      <button
        type="button"
        className={classes.reportButton}
        onClick={onReportClick}
      >
        {t.reportButton}
      </button>
    </div>
  );
}
